import { useEffect, useState } from "react";
import moment from "moment";
import { Alert, Button, ButtonLink, Card, CardBody, ContentLoader, LoadingSpinner } from "@webtypen/react-components";
import { ShiftRequestStatus } from "./ApplyForShiftForm";
import { ApiHelper, ConfirmHelper } from "../helpers";

export const ShiftRequestQuickHandle = ({ shiftRequestId, onChange }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isHandling, setIsHandling] = useState(null);
    const [data, setData] = useState(null);

    const handleShiftRequest = (e) => {
        const type = e.currentTarget.getAttribute("data-type");

        setIsHandling(type);
        ApiHelper.request("/api/contracts/handle-shift-request", {
            _id: data._id,
            shift: data.shift,
            type: type,
        })
            .then((response) => {
                if (response.status !== "success") {
                    ConfirmHelper.alert(
                        response.status === "error" && response.message && response.message.trim() !== ""
                            ? response.message
                            : "Es ist ein unerwarteter Fehler aufgetreten ..."
                    );
                }

                load(() => {
                    setIsHandling(null);
                });

                if (onChange) {
                    onChange();
                }
            })
            .catch((e) => {
                console.error(e);

                ConfirmHelper.alert(
                    e && e.data && e.data.status === "error" && e.data.message && e.data.message.trim() !== ""
                        ? e.data.message
                        : "Es ist ein unerwarteter Fehler aufgetreten ..."
                );

                load(() => {
                    setIsHandling(null);
                });

                if (onChange) {
                    onChange();
                }
            });
    };

    const load = (callback) => {
        ApiHelper.request("/api/contracts/shifts/requests/details", {
            _id: shiftRequestId,
        })
            .then((response) => {
                setData(response.status === "success" && response.data && response.data._id ? response.data : null);
                setIsLoading(false);

                if (callback) {
                    callback(response);
                }
            })
            .catch((e) => {
                console.error(e);
                setData(null);
                setIsLoading(false);

                if (callback) {
                    callback(e.data);
                }
            });
    };

    useEffect(() => {
        setIsLoading(true);
        load();
    }, [shiftRequestId]);

    if (!shiftRequestId) {
        return <Alert danger>Missing shift-request-id ...</Alert>;
    }

    if (isLoading) {
        return <ContentLoader />;
    }

    if (!data) {
        return <Alert danger>Schicht-Bewerbung `{shiftRequestId}` konnte nicht geladen werden ...</Alert>;
    }

    return (
        <>
            <h3 className="mt-0">
                <ShiftRequestStatus status={data.status} className="mr-2" />

                {data.employee_object.firstname ? data.employee_object.firstname + " " : ""}
                {data.employee_object.lastname}
                {" für "}
                {data.customer_object.name}
            </h3>

            <div>
                <span style={{ fontWeight: "600" }}>
                    {data.shift_object.date ? moment(data.shift_object.date).format("DD.MM.YYYY") + ": " : ""}
                </span>
                {"Von "}
                {data.shift_object.begin_planned ? data.shift_object.begin_planned + " Uhr" : "?"} bis{" "}
                {data.shift_object.end_planned ? data.shift_object.end_planned + " Uhr" : "?"}
            </div>
            <div className="mt-2">
                <div style={{ fontWeight: "600" }}>Mitarbeiter-Notiz:</div>
                {data.note ? data.note : "-"}
            </div>

            {data.shift_object.employee_object ? (
                <Card className="mt-2 bg-warning">
                    <CardBody>
                        {data.shift_object.employee_object ? (
                            <>
                                Diese Schicht wurde bereits{" "}
                                <b>
                                    {data.shift_object.employee_object.firstname +
                                        (data.shift_object.employee_object.lastname
                                            ? " " + data.shift_object.employee_object.lastname
                                            : "")}
                                </b>{" "}
                                zugeteilt!
                            </>
                        ) : (
                            "Diese Schicht wurde bereits einem Mitarbeiter zugeteilt!"
                        )}
                    </CardBody>
                </Card>
            ) : null}

            <div className="mt-2">
                <ButtonLink light sm disabled={isHandling} to={"/contracts/" + data.contract_object._id + "/edit"}>
                    Auftrag öffnen
                </ButtonLink>

                <Button
                    type="button"
                    sm
                    success
                    onClick={handleShiftRequest}
                    data-type="confirm"
                    disabled={isHandling || data.status !== "pending"}
                    className="ml-2"
                >
                    {isHandling === "confirm" ? <LoadingSpinner /> : "Annehmen"}
                </Button>
                <Button
                    type="button"
                    sm
                    danger
                    onClick={handleShiftRequest}
                    data-type="decline"
                    disabled={isHandling || data.status !== "pending"}
                    className="ml-2"
                >
                    {isHandling === "decline" ? <LoadingSpinner /> : "Ablehnen"}
                </Button>
            </div>
        </>
    );
};
